import React from "react"

function PlayingCard(props) {
    function handleClick() {
        const name = props.name
        const match = props.match
        props.callBackFlip(name, match)
    }
    
    return (
        <div className="flipCardWrapper playingCardWrapper" id={props.name} match={props.match} onClick={handleClick}>
            <div className="flipCard">
                <div className="flipCardFront playingCardFront"></div>
                <div className={"flipCardBack playingCardBack " + props.cardText}></div>
            </div>
        </div>
    )
}

export default PlayingCard